module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("duWpY"))).then(() => parcelRequire('jYO9D'));